import { isEmptyObject } from '@jfs/utils'
import { lineColors } from '../../screens/Insights/graph/chartConfig'
import { getFormatedMoney } from './../../util/util'

const graphKeyWrapper: any = {
  CC: 'Credit Card',
  DC: 'Debit Card',
  Netbanking: 'Net Banking',
  UPI: 'Upi',
  Wallet: 'Wallet',
  VISA: 'Visa',
  MASTER: 'Master',
  RUPAY: 'Rupay',
  Others: 'Others',
  HDFC: 'Hdfc',
  ICICI: 'ICICI',
  SBI: 'Sbi',
  KOTAK: 'Kotak',
  OTHER: 'Other',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  PENDING: 'Pending',
  BOUNCE: 'Bounce',
  MOBILE: 'Mobile',
  DESKTOP: 'Desktop',
  'Collect Link': 'Collect Link',
  Unknown: 'Unknown',
}

export const formatSegmetedData = (segemetedData: any) => {
  const formattedArray: any[] = segemetedData
    .map((item: any) => {
      return {
        segment: graphKeyWrapper[item.type] ?? item.type,
        type: item.type,
        value: parseFloat(item?.value)?.toFixed(2) ?? 0,
        percentage: `${item?.percent}%`,
      }
    })
    .sort((a: any, b: any) => (Number(a.value) > Number(b.value) ? -1 : Number(a.value) < Number(b.value) ? 1 : 0))

  /*  if (segemetedData && segemetedDataStringArray) {
    console.log('segemetedDataStringArray', segemetedDataStringArray)
    segemetedDataStringArray.forEach((segmentedString) => {
      console.log('segmentedString', segmentedString)
      const item = segemetedData.find((element: any) => element.type === segmentedString)
      if (item) {
        formattedArray.push({
          segment: graphKeyWrapper[item.type] ?? item.type,
          value: parseFloat(item?.value)?.toFixed(2) ?? 0,
          percentage: `${item?.percent}%`,
        })
      } else {
        formattedArray.push({
          segment: graphKeyWrapper[segmentedString] ?? segmentedString,
          value: '0.00',
          percentage: '0%',
        })
      }
    })
  } */
  return formattedArray
}

export const getTypesArray = (segemetedData: any) => {
  const typeKeys: any[] = segemetedData
    .sort((a: any, b: any) => (Number(a.value) > Number(b.value) ? -1 : Number(a.value) < Number(b.value) ? 1 : 0))
    .map((item: any) => {
      return item.type
    })

  return typeKeys
}

export const getChartData = (
  data: any,
  typeKeysArray: any,
  transactionsBy: string,
  showPercent: boolean,
  isVsSelected: boolean,
): any => {
  const filedData = getChartFields(
    data.graphData,
    typeKeysArray,
    isVsSelected ? data.insightTypes : data.timestamps,
    transactionsBy,
    showPercent,
    isVsSelected,
  )
  if (filedData.data.length === 0) {
    return { data: [], xAxis: [] }
  }

  return {
    data: [getLineChartHeader(data.graphData, typeKeysArray, showPercent, isVsSelected), ...filedData.data],
    xAxis: filedData.xAxis,
  }
}

export const getLegendData = (data: any) => {
  let total = 0
  const keys = !!data && !isEmptyObject(data) ? Object.keys(data) : []
  keys?.map((item: any) => {
    data[item]?.insightValue?.map((value: any) => {
      total += parseInt(value, 10)
    })
  })
  const retData: any = []

  const getValue = (values: any) => {
    const value = values?.reduce((item: any, acc: any) => {
      return parseInt(acc, 10) + parseInt(item, 10)
    })
    return parseInt(value, 10)?.toFixed(2)?.toString()
  }
  const getPercent = (values: any) => {
    const percent: number = values?.reduce((item: any, acc: any) => {
      return parseInt(acc, 10) + parseInt(item, 10)
    })
    return ((percent * 100) / total)?.toFixed(2).toString() + '%'
  }
  keys?.map((item: any) => {
    const retItem = {
      segment: graphKeyWrapper[item] ?? item,
      type: item,
      percentage: getPercent(data[item]?.insightValue),
      value: getValue(data[item]?.insightValue),
      checked: true,
    }
    retData.push(retItem)
  })
  return retData
}
const getLineChartHeader = (graphData: any, typeKeysArray: any, showPercent: boolean, isVsSelected: boolean) => {
  const headers: any = ['timestamps']
  typeKeysArray.map((key: any) => {
    const values = isVsSelected ? graphData[key].insightValue : graphData[key].values
    const percent = isVsSelected ? graphData[key].insightPercent : graphData[key].percent
    if (showPercent ? percent : values) {
      headers.push(graphKeyWrapper[key] ?? key)
      headers.push('customTooltipFieldObj')
    }
  })
  return headers
}
const createCustomHTMLContent = (
  bgColor: any,
  fieldName: any,
  xAxisPoint: any,
  value: any,
  transactionsBy: string,
  showPercent: boolean,
) => {
  let formattedValue = getFormatedMoney(value, transactionsBy === 'by_Count' && !showPercent)
  if (showPercent) {
    formattedValue = formattedValue.replace('₹ ', '') + ' %'
  }

  let volume = transactionsBy === 'by_Value' ? 'Transaction Value' : 'Transaction Count'

  const html = `
    <div style="background-color: ${bgColor}; padding: 16px; border-radius: 4px; align-self: start; box-shadow: rgb(136, 136, 136) .5px .5px .5px .5px; flex-direction: column; font-size:12px; font-family: jioType-medium;">
      <div style="flex-direction: column; margin-right: 100px;">
        <div style="color: white; margin-bottom: 8px;">
          ${fieldName}
        </div>
        <div style="color: white; margin-bottom: 15px; font-family: jioType-bold;">
          ${xAxisPoint}
        </div>
      </div>
      <div style="height: 1px; background-color: rgb(211, 211, 211);"></div>
      <div style="flex-direction: column;">
        <div style="color: white; margin-top: 15px; margin-bottom: 8px;">${volume}</div>
        <div style="color: white; font-family: jioType-bold;">${formattedValue}</div>
      </div>
    </div>`

  return html
}

const getHourFormatDate = (xdate: Date) => {
  const hours = xdate.getHours() < 10 ? `0${xdate.getHours()}` : xdate.getHours()
  const minutes = xdate.getMinutes() < 10 ? `0${xdate.getMinutes()}` : xdate.getMinutes()
  return xdate.getDate() + '-' + xdate.toLocaleString('default', { month: 'short' }) + ' ' + hours + ':' + minutes
}

const getChartFields = (
  graphData: any,
  typeKeysArray: any,
  timestamps: any,
  transactionsBy: string,
  showPercent: boolean,
  isVsSelected: boolean,
) => {
  const fieldData: any = []
  try {
    for (const key of typeKeysArray) {
      const values = isVsSelected ? graphData[key].insightValue : graphData[key].values
      const percent = isVsSelected ? graphData[key].insightPercent : graphData[key].percent
      let xdate: any
      if (values || percent) {
        if (fieldData.length === 0) {
          timestamps.forEach((element: any) => {
            if (typeof element === 'number' || (!isNaN(element) && element.length > 4)) {
              if (typeof element === 'string') {
                xdate = new Date(+element)
                fieldData.push([getHourFormatDate(xdate)])
              } else {
                xdate = new Date(element)
                fieldData.push([getHourFormatDate(xdate)])
              }
            } else {
              fieldData.push([element])
            }
          })
        }
        const dataValuesOrPercent = showPercent ? percent : values
        dataValuesOrPercent.forEach((element: any, index: number) => {
          fieldData[index].push(typeof element === 'number' ? element : parseFloat(element))
          const fieldName = getLineChartHeader(graphData, typeKeysArray, showPercent, isVsSelected)[
            fieldData[index].length - 1
          ]
          const xAxisPoint = fieldData[index][0]
          fieldData[index].push(
            createCustomHTMLContent(
              lineColors[Math.floor(fieldData[index].length / 2 - 1) % 15]?.color,
              fieldName,
              xAxisPoint,
              parseFloat(element),
              transactionsBy,
              showPercent,
            ),
          )
        })
      }
    }
  } catch (e) {
    console.log('error while parsing', e)
  }
  return { data: fieldData, xAxis: timestamps }
}
